import { Permissions } from "./Permissions";


class RoleImpl {
  public EHPC_READ = 'ROLE_EHPC_READ';

  public EHPC_REQU = 'ROLE_EHPC_REQU';

  public EHPC_RW = 'ROLE_EHPC_RW';

}
export const Role = new RoleImpl();


export const Roles = {

  EHPC_READ: [
    Permissions.ParameterKomponenteRead,
    Permissions.ParameterKomponenteDownload,
    Permissions.ParameterRead,
    Permissions.ParameterDownload
  ],
  EHPC_REQU: [
    Permissions.ParameterKomponenteRead,
    Permissions.ParameterKomponenteCreate,
    Permissions.ParameterKomponenteUpdate,
    Permissions.ParameterKomponenteDownload,

    Permissions.ParameterCreate,
    Permissions.ParameterRead,
    Permissions.ParameterUpdate,
    Permissions.ParameterDownload,

    Permissions.RequestInfoEmail,
    Permissions.RequestInfoEmailView,
    Permissions.RequestInfoEmailNew,
    Permissions.RequestInfoEmailEdit,
    Permissions.RequestInfoSource,
    Permissions.RequestInfoSourceView,
    Permissions.RequestInfoSourceNew,
    Permissions.RequestInfoSourceEdit,
  ],
  EHPC_RW: [
    Permissions.ParameterKomponenteRead,
    Permissions.ParameterKomponenteCreate,
    Permissions.ParameterKomponenteUpdate,
    Permissions.ParameterKomponenteDelete,
    Permissions.ParameterKomponenteRelease,
    Permissions.ParameterKomponenteUpdate,

    Permissions.ParameterCreate,
    Permissions.ParameterRead,
    Permissions.ParameterUpdate,
    Permissions.ParameterDelete,
    Permissions.ParameterDownload,
    Permissions.ParameterRelease,
    Permissions.FileUpload,

    Permissions.RequestInfoAnnotation,
    Permissions.RequestInfoEmail,
    Permissions.RequestInfoEmailView,
    Permissions.RequestInfoEmailNew,
    Permissions.RequestInfoEmailEdit,
    Permissions.RequestInfoEmailDelete,
    Permissions.RequestInfoSource,
    Permissions.RequestInfoSourceView,
    Permissions.RequestInfoSourceNew,
    Permissions.RequestInfoSourceEdit,
    Permissions.RequestInfoSourceDelete,
  ]
}
